<template>
	<dms-wrapper :label="labelText" v-bind="{span, wrapp, validationRules, ...$attrs}" :validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-slider :value="value" :min="min" :max="max" :step="step" :marks="computedMarks" :data-cy="labelKey" :show-tooltip="false" :disabled="isDisabled"
			@input="updateValue($event)" />
	</dms-wrapper>
</template>

<script>
import _ from 'lodash';

import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsSlider',
	components: { DmsWrapper },
	props: {
		min: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			required: true,
		},
		step: {
			type: Number,
			default: 1,
		},
		marks: {
			type: Object,
			required: true,
		},
		span: {
			type: Number,
			default: 24,
		},
	},
	methods: {
		updateValue(event) {
			this.$emit('update:value', event);
		},
	},
	computed: {
		computedMarks() {
			// fix first and last mark inconsistent position
			const maxMark = _.max(_.keys(this.marks));
			const marksToReturn = _.clone(this.marks);

			marksToReturn[0] = {
				style: 'margin-left: 10px;',
				label: marksToReturn[0],
			};
			marksToReturn[maxMark] = {
				style: 'margin-right: 10px;',
				label: marksToReturn[maxMark],
			};
			return marksToReturn;
		},
	},
});
</script>
